export default __webpack_public_path__ + "static/media/playstore-icon.216a953e.png";